import { SideModal } from '@design-system/components/modal/sideModal';
import { extrasVM } from '../Extras.page';
import { VideoModal } from './video.modal';
import { VideoForm } from './video.form';
import { VideoThumbnailModal } from './video-thumbnail.modal';

export const VideoView = () => {
  const vm = extrasVM.useValue().videoVM;

  return (
    <>
      {(vm.mode === 'create' || vm.mode === 'reuploading') && (
        <VideoModal
          isOpen
          onClose={() => vm.dispatch('Cancel')}
          onVideoPicked={(value) => vm.dispatch('VideoSelected', value)}
          mode={vm.mode === 'create' ? vm : null}
        />
      )}
      <SideModal
        isOpen={
          vm.mode === 'edit' ||
          vm.mode === 'reuploading' ||
          vm.mode === 'thumbnail-edit'
        }
        onClose={() => vm.dispatch('Cancel')}
        noSpacing
      >
        <div style={{ padding: '24px 45px' }}>
          <VideoForm />
        </div>
      </SideModal>

      <VideoThumbnailModal
        isOpen={vm.mode === 'thumbnail-edit'}
        onClose={() => vm.dispatch('Cancel')}
        onThumbnailPicked={({ thumbnailCustomURL, thumbnailTimestampMs }) =>
          vm.dispatch('SelectThumbnail', {
            thumbnailCustomURL,
            thumbnailTimestampMs,
          })
        }
        thumbnail={{
          url: vm.content.thumbnailCustomURL,
          time: vm.content.thumbnailTimestampMs || 0,
        }}
        duration={(vm.content?.durationMs || 38000) / 1000}
        muxPlaybackId={vm.content.muxPlaybackId}
      />
    </>
  );
};
